import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { translate } from 'i18n/i18n'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const windSpeed: typeof valueTypeRenderers.windSpeed = {
  label: () => unitConverter.windSpeed().titleWithoutUnit(),
  point: () =>
    makeNumberRenderer({
      baseLabel: translate.phrases.templates('{{labelA}} ({{labelB}})', {
        labelA: unitConverter.windSpeed().titleWithoutUnit(),
        labelB: unitConverter.windSpeed().suffix(),
      }),
      render: (n) => unitConverter.windSpeed(n).valueAsString(),
    }),
}
